





























































import Vue from "vue";
import BaseStripeTable from "@/components/Common/BaseStripeTable.vue";
import PaymentStatusChip from "@/components/Common/PaymentStatusChip.vue";

export default Vue.extend({
  name: "PaymentHistoryCard",
  components: { BaseStripeTable, PaymentStatusChip },
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async onSelectPayment(id: string) {
      this.$emit("selectedPayment", { title: "paymentDetails", paymentId: id });
    },
  },
});
